import isoDateToDDMMYYYY from "./isoDateToDDMMYYYY";
import { SubmissionResultItem } from "../containers/NewOrderContainer/types";

function responseToSubmissionResultItems(response?: any[] | null) {
  if (!response) {
    return [];
  }
  const results = response.map(s => {
    const failedReasonsAreMany = s.failedReason && s.failedReason.problems;
    let failedReason = undefined;

    if (failedReasonsAreMany && s.failedReason.problems.length > 0) {
      failedReason =
        s.failedReason.problems
          .map((p: any) => p.message)
          .join(". ")
          .trim() + ".";
    } else {
      const failedReasonCode = s.failedReason;
      failedReason =
        failedReasonCode === "Order.Currency.Unavailable"
          ? "The currency/denominations selected are currently unavailable."
          : "Return.Currency.Unavailable"
          ? "The currency selected is currently unavailable."
          : null;
    }

    return {
      id: s.id,
      version: s.version,
      branchName: s.branchName,
      currencyName: s.currencyName,
      currencyRegion: s.currencyRegion,
      currencyCode: s.currencyCode,
      currencySymbol: s.currencySymbol,
      currencyAmount: s.currencyAmount,
      baseCurrencyCode: s.baseCurrencyCode,
      baseCurrencySymbol: s.baseCurrencySymbol,
      baseCurrencyAmount: s.baseCurrencyAmount,
      orderedAt: isoDateToDDMMYYYY(s.orderedAt),
      requiredAt: isoDateToDDMMYYYY(s.requiredAt),
      travellerBeneficiary: s.travellerBeneficiary,
      orderAuthorisationReason:
        s.orderAuthorisationReason === 1
          ? "Rejected due to breach of order limit."
          : s.orderAuthorisationReason === 2
          ? "Rejected due to breach of daily limit."
          : s.orderAuthorisationReason === 3
          ? "Rejected due to breach of both order limit and daily limit."
          : null,
      availableAuthorisers: s.availableAuthorisers,
      failedReason
    };
  }) as SubmissionResultItem[];
  return results;
}

export default responseToSubmissionResultItems;
